'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

// $(document).ready(function() {
//     if($('.edit').length) {
//         $('.confirmationMessage').modal('show');
//     }
// });



$('#CaseCreationForm').on('propertychange input', 'input.phone', function (e) {
    var $input = $(this);
    var maxlength = 12;
    $input.val($input.val().replace(/[^\d]+/g, ''));
    limitInput(maxlength, $input);
});

module.exports = {
    subscribeContact: function () {
        $('form#CaseCreationForm').on('submit', function (e){
            e.preventDefault();
            var form = $(this);
            $.ajax({
                url: $(this).attr('action'),
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if(data.success){
                        $('.confirmationMessage').modal('show');
                        $('#CaseCreationForm').trigger("reset");
                    }
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        
        });
    }
};
